// エリア/ハブのナビ画像は、いずれも各シーンの AreaMap（マップ画像）をサムネ化して使う。
// AreaMap は原寸 2K で 300〜668KB あり、リスト用途には重すぎる。Vite/Nuxt は画像を
// リサイズせず原寸配信するため、リスト専用の 320px webp サムネ（各 8〜33KB、map/thumb/）を
// 用意して差し込む（生成: scripts/gen_area_thumbs.py。#721）。
// ※ 以前は world の一部エリアに EmporiumIcon（正方の商品アイコン）を使っていたが、
//    「各エリアはそのマップ画像で統一」との要望で AreaMap サムネに揃えた（#721）。
import areaBeginnersPort from '@/assets/images/map/thumb/AreaMap_BeginnersPort.webp'
import areaSlumberingBeach from '@/assets/images/map/thumb/AreaMap_SlumberingBeach.webp'
import areaCrystalWaveIsland from '@/assets/images/map/thumb/AreaMap_CrystalWaveIsland.webp'
import areaSilverLeafForest from '@/assets/images/map/thumb/AreaMap_SilverLeafForest.webp'
import areaEncodia from '@/assets/images/map/thumb/AreaMap_Encodia.webp'
import areaArcaneLab from '@/assets/images/map/thumb/AreaMap_ArcaneLab.webp'
import areaCradle from '@/assets/images/map/thumb/AreaMap_CradleOfFeatherQuill.webp'
import areaEmporium from '@/assets/images/map/thumb/AreaMap_Emporium.webp'
import areaCamp from '@/assets/images/map/thumb/AreaMap_AdventurersCamp.webp'
// #900: 冒険の手記の棚（2:3 の額）に入れる縦位置サムネ。横版を cover で入れると左右が
// 大きく切れたうえ縦に伸びてぼやけるので、中央トリミングした専用サムネを焼いてある
// （生成: scripts/gen_area_thumbs.py の `_portrait`。320x480 / 4 枚で 98KB）。
import portraitBeginnersPort from '@/assets/images/map/thumb/portrait/AreaMap_BeginnersPort.webp'
import portraitSlumberingBeach from '@/assets/images/map/thumb/portrait/AreaMap_SlumberingBeach.webp'
import portraitSilverLeafForest from '@/assets/images/map/thumb/portrait/AreaMap_SilverLeafForest.webp'
import portraitCrystalWaveIsland from '@/assets/images/map/thumb/portrait/AreaMap_CrystalWaveIsland.webp'

// #721: モバイルナビの画像付きリストで使う「そのシーンの代表画像」を解決する。
//  - ワンダー（story）: デモ動画（YouTube）のサムネイル。video_id を持つものだけ。
//  - エリア/ハブ: 各シーンの AreaMap（マップ画像）のサムネ。
//  - どれも無ければ undefined（MobileListCard 側でプレースホルダ表示）。
const AREA_IMAGE: Record<string, string> = {
  wld_beginnersPort: areaBeginnersPort,
  wld_slumberingBeach: areaSlumberingBeach,
  wld_crystalWaveIsland: areaCrystalWaveIsland,
  wld_silverLeafForest: areaSilverLeafForest,
  wld_encodia: areaEncodia,
  cmp_arcaneLab: areaArcaneLab,
  cmp_cradle: areaCradle,
  cmp_emporium: areaEmporium,
  cmp_adventurersCamp: areaCamp,
}

// YouTube のサムネイル URL。hqdefault は常に存在し 480x360（比較的高解像）。
export function youtubeThumbnail(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
}

const AREA_PORTRAIT: Record<string, string> = {
  wld_beginnersPort: portraitBeginnersPort,
  wld_slumberingBeach: portraitSlumberingBeach,
  wld_silverLeafForest: portraitSilverLeafForest,
  wld_crystalWaveIsland: portraitCrystalWaveIsland,
}

/**
 * 2:3 の縦位置に切ったエリアのマップ画像（#900 冒険の手記の棚）。
 *
 * まだ公開していないエリアは持たない（`undefined`）。公開したらサムネを焼いて
 * ここに足す（`scripts/gen_area_thumbs.py` の `PORTRAIT_NAMES`）。
 */
export function areaPortraitFor(sceneId: string): string | undefined {
  return AREA_PORTRAIT[sceneId]
}

export function sceneImageFor(scene: { sceneId: string, videoId?: string }): string | undefined {
  if (scene.videoId) {
    return youtubeThumbnail(scene.videoId)
  }
  return AREA_IMAGE[scene.sceneId]
}
